export const vidFromString = (str) => ({ names: str.split('::') });
export const vidToString = (vid) => vid.names.join('::');
export const vidEq = (a, b) => {
    if (a.names.length !== b.names.length)
        return false;
    for (let i = 0; i < a.names.length; i++) {
        if (a.names[i] !== b.names[i])
            return false;
    }
    return true;
};
export const vidFromScope = (vid) => ({ names: vid.names.slice(0, -1) });
export const idToVid = (id) => ({ names: id.names.map(s => s.value) });
export const concatVid = (a, b) => ({
    names: [...a.names, ...b.names]
});
export const findMain = (module) => {
    if (module.mod && module.identifier.names.length === 1) {
        return module.block.statements.find(s => s.kind === 'fn-def' && s.pub && s.name.value === 'main');
    }
    return undefined;
};
//# sourceMappingURL=util.js.map